import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useEffect, useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import { Approval, BlockOutlined, CancelOutlined, CopyAll, LibraryBooksOutlined, Link as LinkIcon, PauseCircleOutline, PlayArrow, PlayCircleOutline, TaskAltOutlined } from '@material-ui/icons';
// material
import { useTheme } from '@material-ui/core/styles';
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText, Box } from '@material-ui/core';
import { useNavigate } from 'react-router';
import { PATH_DASHBOARD } from 'src/routes/paths';
import plusFill from '@iconify/icons-eva/plus-fill';
import downloadFill from '@iconify/icons-eva/download-fill';
import eyeFill from '@iconify/icons-eva/eye-fill';
import { useSnackbar } from 'notistack';


// routes 

// ----------------------------------------------------------------------

UserMoreMenu.propTypes = {
  onDelete: PropTypes.func,
  onVoid: PropTypes.func,
  userName: PropTypes.string,
  hideMenu: PropTypes.bool,
  onMoveToProduction: PropTypes.func,
  onMoveToInstall: PropTypes.func,
  onMoveToTS: PropTypes.func,
  onMoveToSubContract: PropTypes.func,
  onMoveToEstimateServices: PropTypes.func,
  onMoveToDesignServices: PropTypes.func,
  onMoveToAdminServices: PropTypes.func
};

export default function UserMoreMenu({ text,onApprove, onDelete, onVoid, onHold, onReject, onRestore, onReopen, onMoveToInprogress, hold, onEdit, onDeactivate,onStatusChange,status,
  isOpportunity,oppName,oppId,fromCrmCalls,noEdit,addToLeadPhone,common,common2,linkImageWithTask,linkImageWithService,unlinkImageWithTask,unlinkImageWithService,onDownload,
  onView, onExistingLead,onDuplicate,currentTab,onViewDetails,project,userType,Deletedisabled,onAddCatalog, hideMenu,
  onMoveToProduction,onMoveToInstall,onMoveToTS,onMoveToSubContract,onMoveToEstimateServices,onMoveToDesignServices,onMoveToAdminServices,onLinkModule }) {
  
  const ref = useRef(null);
  const theme = useTheme()
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const user = JSON.parse(localStorage.getItem('user'))
  const explodedPermissions =user?.exploded_permissions

  const handleNavigate = (id) => {
    navigate(`${PATH_DASHBOARD.client.addClient}/${'client'}`, { state: { crmName: oppName, fromCrm:true } });
  };
  
  const handleNavigateCrmCall = (fromCrmCalls,addToLeadPhone) => {
    setIsOpen(false)
    if(addToLeadPhone){
      console.log("add to lead",addToLeadPhone);
      // navigate(PATH_DASHBOARD.crm.addlead, { state: { addToLeadPhone : addToLeadPhone } });
    }
    else{
      onExistingLead();
      console.log("add to existing lead");
    }
  };

  useEffect(() => {
    if(common && common.modalClose){
      setIsOpen(false)
    }
    if(common2 && common2.modalClose){
      setIsOpen(false)
    }
    if(linkImageWithTask && linkImageWithTask.modalClose){
      setIsOpen(false)
    }
    if(unlinkImageWithTask && unlinkImageWithTask.modalClose){
      setIsOpen(false)
    }
    if(linkImageWithService && linkImageWithService.modalClose){
      setIsOpen(false)
    }
    if(unlinkImageWithService && unlinkImageWithService.modalClose){
      setIsOpen(false)
    }
  },[common?.modalClose,common2?.modalClose,linkImageWithTask?.modalClose,linkImageWithService?.modalClose,unlinkImageWithTask?.modalClose,unlinkImageWithService?.modalClose])

  return (
    <>
      <IconButton
        sx={{
          color:
            theme.palette.mode === 'light'
              ? theme.palette.text.secondary
              : theme.palette.grey[400]
        }}
        ref={ref}
        onClick={(e) => { e.stopPropagation(); setIsOpen(true)}}
        disabled={hideMenu}
      >
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={(event) => { event?.stopPropagation(); setIsOpen(false) }}
        PaperProps={{
          sx: { width: 240, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >

        {[noEdit || 
        ((common && common.name) && <MenuItem onClick={(e) => {e.stopPropagation(); common.function()}}>
          {common.Iccon}
          <ListItemText sx={{marginLeft:2}} primary={common.name} primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>),

        ((linkImageWithTask && linkImageWithTask.name) && <MenuItem onClick={(e) => {e.stopPropagation(); linkImageWithTask.function()}}>
          {linkImageWithTask.Iccon}
          <ListItemText sx={{marginLeft:2}} primary={linkImageWithTask.name} primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>),

        ((linkImageWithService && linkImageWithService.name) && <MenuItem onClick={(e) => {e.stopPropagation(); linkImageWithService.function()}}>
          {linkImageWithService.Iccon}
          <ListItemText sx={{marginLeft:2}} primary={linkImageWithService.name} primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>),

        ((unlinkImageWithTask && unlinkImageWithTask.name) && <MenuItem onClick={(e) => {e.stopPropagation(); unlinkImageWithTask.function()}}>
          {unlinkImageWithTask.Iccon}
          <ListItemText sx={{marginLeft:2}} primary={unlinkImageWithTask.name} primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>),

        ((unlinkImageWithService && unlinkImageWithService.name) && <MenuItem onClick={(e) => {e.stopPropagation(); unlinkImageWithService.function()}}>
          {unlinkImageWithService.Iccon}
          <ListItemText sx={{marginLeft:2}} primary={unlinkImageWithService.name} primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>),

        ((common2  && common2.name) && <MenuItem onClick={(e) => {e.stopPropagation(); common2.function()}} >
        {common2.Iccon}
        <ListItemText sx={{marginLeft:2}} primary={common2.name} primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>),

        (onAddCatalog && <MenuItem 
          onClick={(e) => { e.stopPropagation(); onAddCatalog(); setIsOpen(false) }} 
          sx={{
            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(25, 118, 210, 0.16)' : 'rgba(25, 118, 210, 0.08)',
            '&:hover': {
              backgroundColor: theme.palette.mode === 'dark' ? 'rgba(25, 118, 210, 0.24)' : 'rgba(25, 118, 210, 0.12)',
            },
            borderTop: `2px solid ${theme.palette.primary.main}`,
            borderBottom: `1px solid ${theme.palette.divider}`,
            mb: 0.5,
            mt: 0.5
          }}
        >
          <ListItemIcon>
            <Icon icon={plusFill} width={24} height={24} style={{ color: theme.palette.primary.main }} />
          </ListItemIcon>
          <ListItemText 
            primary="Add Catalog" 
            primaryTypographyProps={{ 
              variant: 'body2',
              sx: { 
                fontWeight: 600,
                color: theme.palette.primary.main
              } 
            }} 
          />
        </MenuItem>
      ),
        (onView && <MenuItem onClick={(e) => { e.stopPropagation(); onView(); setIsOpen(false) }} >
        <ListItemIcon>
          <Icon icon={eyeFill} width={24} height={24} />
        </ListItemIcon>
        <ListItemText primary="View" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>),

        (onDownload && <MenuItem onClick={(e) => { e.stopPropagation(); onDownload(); setIsOpen(false) }} >
        <ListItemIcon>
          <Icon icon={downloadFill} width={24} height={24} />
        </ListItemIcon>
        <ListItemText primary="Download" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>),

        onHold && (
          <MenuItem onClick={(e) => {
            e.stopPropagation(); 
            onHold()
            setIsOpen(false)
          }} >
            <ListItemIcon>
              { hold===1 ? <PlayCircleOutline sx={{ width: 25, height: 25 }} /> : <PauseCircleOutline sx={{ width: 25, height: 25 }} /> }
            </ListItemIcon>
            <ListItemText primary= {hold===1 ? "Release from Hold" : "Move to Hold"} primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        ),

        onReject && (
          <MenuItem onClick={(e) => {
            e.stopPropagation();
            onReject();
            setIsOpen(false);
          }}>
            <ListItemIcon>
              <CancelOutlined sx={{ width: 25, height: 25, color: theme.palette.error.main }} />
            </ListItemIcon>
            <ListItemText
              primary="Reject"
              primaryTypographyProps={{ variant: 'body2', sx: { color: theme.palette.error.main } }}
            />
          </MenuItem>
        ),

        onRestore && (
          <MenuItem onClick={(e) => {
            e.stopPropagation();
            onRestore();
            setIsOpen(false);
          }}>
            <ListItemIcon>
              <TaskAltOutlined sx={{ width: 25, height: 25, color: theme.palette.success.main }} />
            </ListItemIcon>
            <ListItemText
              primary="Restore"
              primaryTypographyProps={{ variant: 'body2', sx: { color: theme.palette.success.main } }}
            />
          </MenuItem>
        ),

        onReopen && (
          <MenuItem onClick={(e) => {
            e.stopPropagation();
            onReopen();
            setIsOpen(false);
          }}>
            <ListItemIcon>
              <TaskAltOutlined sx={{ width: 25, height: 25, color: theme.palette.primary.main }} />
            </ListItemIcon>
            <ListItemText
              primary="Reopen"
              primaryTypographyProps={{ variant: 'body2', sx: { color: theme.palette.primary.main } }}
            />
          </MenuItem>
        ),

        onMoveToInprogress && (
          <MenuItem onClick={(e) => { e.stopPropagation(); onMoveToInprogress(); setIsOpen(false) }} >
            <ListItemIcon>
              { <PlayArrow sx={{ width: 25, height: 25 }} /> }
            </ListItemIcon>
            <ListItemText primary= {"Move to Inprogress"} primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        ),

        (onMoveToProduction && <MenuItem onClick={(e) => { e.stopPropagation(); onMoveToProduction(); setIsOpen(false) }} >
          <ListItemIcon><span className="ic--outline-move-down" /></ListItemIcon>
          <ListItemText primary="Move to Production" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>),

        (onMoveToSubContract && <MenuItem onClick={(e) => { e.stopPropagation(); onMoveToSubContract(); setIsOpen(false) }} >
          <ListItemIcon><span className="hugeicons--square-arrow-move-right-up" /></ListItemIcon>
          <ListItemText primary="Move to Sub Contract" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>),
        
        (onMoveToInstall && <MenuItem onClick={(e) => { e.stopPropagation(); onMoveToInstall(); setIsOpen(false) }} >
          <ListItemIcon><span className="hugeicons--circle-arrow-move-up-right" /></ListItemIcon>
          <ListItemText primary="Move to Install" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>),

        (onMoveToTS && <MenuItem onClick={(e) => { e.stopPropagation(); onMoveToTS(); setIsOpen(false) }} >
          <ListItemIcon><span className="ic--sharp-move-up" /></ListItemIcon>
          <ListItemText primary="Move to T/S" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>),

        (onMoveToEstimateServices && <MenuItem onClick={(e) => { e.stopPropagation(); onMoveToEstimateServices(); setIsOpen(false) }} >
          <ListItemIcon><span className="hugeicons--circle-arrow-move-up-right" /></ListItemIcon>
          <ListItemText primary="Move to Estimate Services" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>),

        (onMoveToDesignServices && <MenuItem onClick={(e) => { e.stopPropagation(); onMoveToDesignServices(); setIsOpen(false) }} >
          <ListItemIcon><span className="hugeicons--circle-arrow-move-up-right" /></ListItemIcon>
          <ListItemText primary="Move to Design Services" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>),

        (onMoveToAdminServices && <MenuItem onClick={(e) => { e.stopPropagation(); onMoveToAdminServices(); setIsOpen(false) }} >
          <ListItemIcon><span className="hugeicons--circle-arrow-move-up-right" /></ListItemIcon>
          <ListItemText primary="Move to Admin Services" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>),

        (onEdit && <MenuItem onClick={(e) => { e.stopPropagation(); onEdit(); setIsOpen(false) }} >
          <ListItemIcon>
            <Icon icon={editFill} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Edit" primaryTypographyProps={{ variant: 'body2' }} />
         
        </MenuItem>
      ),
    (onApprove && <MenuItem onClick={(e) => { e.stopPropagation(); onApprove(); setIsOpen(false) }} >
    <ListItemIcon>
      <Icon icon={eyeFill} width={24} height={24} />
    </ListItemIcon>
    <ListItemText primary="Approve" primaryTypographyProps={{ variant: 'body2' }} />

    </MenuItem>
    ),
    (onDuplicate && <MenuItem onClick={(e) => { e.stopPropagation(); onDuplicate(); setIsOpen(false) }} >
    <ListItemIcon>
      <CopyAll width={24} height={24} />
    </ListItemIcon>
    <ListItemText primary="Duplicate" primaryTypographyProps={{ variant: 'body2' }} />
   
  </MenuItem>
),
    (onLinkModule && <MenuItem onClick={() => { onLinkModule(); setIsOpen(false) }} >
    <ListItemIcon>
      <LinkIcon sx={{ width: 24, height: 24 }} />
    </ListItemIcon>
    <ListItemText primary="Link Module" primaryTypographyProps={{ variant: 'body2' }} />
   
  </MenuItem>
),
      isOpportunity && (<MenuItem 
      onClick={(e) => {
        e.stopPropagation(); 
        if(explodedPermissions?.some(permission => ['Inviting clients'].includes(permission))){
          handleNavigate(oppId)
        }else{
          enqueueSnackbar("Access Denied: You do not have sufficient permissions to add client", { variant: 'error' })
        }
      }} >
          <ListItemIcon>
            <LibraryBooksOutlined sx={{width:25,height:25}}/>
          </ListItemIcon>
          <ListItemText primary="Convert to Client" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>),
        
        fromCrmCalls &&
        (<>
          <MenuItem onClick={(e) => {e.stopPropagation(); handleNavigateCrmCall(fromCrmCalls,addToLeadPhone)}} >
            <ListItemIcon>
            <Icon icon={plusFill} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Add to Lead" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
          {/* <MenuItem onClick={() => handleNavigateCrmCall(fromCrmCalls)} sx={{ color: 'text.secondary' }}>
            <ListItemIcon>
            <Icon icon={plusFill} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary="Add to existing Lead" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem> */}
        </>),

           status !== undefined  &&    (
          <MenuItem onClick={(e) => { e.stopPropagation(); onStatusChange(); setIsOpen(false); }} >
            <ListItemIcon>
            {(status === 1 ? <BlockOutlined sx={{ width: 25, height: 25 }} /> : <TaskAltOutlined sx={{ width: 25, height: 25 }} /> )}
            </ListItemIcon>
            <ListItemText
              primary={text ? text : (status === 1 ? "Deactivate" : "Activate")}
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </MenuItem>
        ),

        onDeactivate && (<MenuItem
          onClick={(e) => {
            e.stopPropagation(); 
            onDeactivate()
            setIsOpen(false)
          }}
        >
          <ListItemIcon>
          {(text ? <TaskAltOutlined sx={{ width: 25, height: 25 }} /> : <BlockOutlined sx={{ width: 25, height: 25 }} /> )}
          </ListItemIcon>
          <ListItemText primary={text ? text : "Deactivate"} primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>),

          onDelete && (<MenuItem onClick={(e) => {
            e.stopPropagation(); 
            onDelete()
            setIsOpen(false)
          }}
          disabled={Deletedisabled}
           >
          <ListItemIcon>
            <Icon icon={trash2Outline} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>),

          onVoid && (<MenuItem onClick={(e) => {
            e.stopPropagation();
            onVoid();
            setIsOpen(false);
          }}>
          <ListItemIcon>
            <CancelOutlined sx={{ width: 25, height: 25, color: theme.palette.error.main }} />
          </ListItemIcon>
          <ListItemText primary="Move to Void" primaryTypographyProps={{ variant: 'body2', sx: { color: theme.palette.error.main } }} />
        </MenuItem>),

          currentTab =='TS' && (<MenuItem onClick={(e) => {
            e.stopPropagation(); 
            onViewDetails()
          }} >
          <ListItemIcon>
            <Icon icon={eyeFill} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Details" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>)

        ]}
      </Menu>
    </>
  );
}
